import React, { Fragment, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Form from './Form';
import './RestorePassword.scss';
import { Helmet } from 'react-helmet';
import * as actions from './RestorePassword.actions';
import * as selectors from './RestorePassword.selectors';

const RestorePassword = (props) => {
    /* State to props */
    const saving = useSelector(selectors.getSaving);
    const password = useSelector(selectors.getPassword);
    const confirmPassword = useSelector(selectors.getConfirmPassword);

    /* Dispatch to props */
    const dispatch = useDispatch();
    const savePassword = useCallback((value) => dispatch(actions.savePassword(value)), [dispatch]);
    const setPassword = useCallback((value) => dispatch(actions.setPassword(value)), [dispatch]);
    const setConfirmPassword = useCallback((value) => dispatch(actions.setConfirmPassword(value)), [dispatch]);
    const setToken = useCallback((value) => dispatch(actions.setToken(value)), [dispatch]);
    const setLoginType = useCallback((value) => dispatch(actions.setLoginType(value)), [dispatch]);
    const setHistory = useCallback((value) => dispatch(actions.setHistory(value)), [dispatch]);
    const resetState = useCallback(() => dispatch(actions.resetState()), [dispatch]);

    /* componentDidMount */
    useEffect(() => {
        resetState();
        setToken(props.match.params.token);
        setLoginType(props.match.params.type);
        setHistory(props.history);
    }, [resetState, setToken, setLoginType, setHistory, props.match.params.token, props.match.params.type, props.history]);

    return (
        <Fragment>
            <Helmet><title>Restore Password</title></Helmet>
            <div className="restore-password-container">
                <h2>Restore Password</h2>
                <Form
                    saving={saving}
                    password={password}
                    confirmPassword={confirmPassword}
                    setPassword={setPassword}
                    setConfirmPassword={setConfirmPassword}
                    savePassword={savePassword}
                />
            </div>
        </Fragment>
    );
};

export default RestorePassword;
